<!-- 腕表商品介绍 -->
<template>
  <div>
    <div class="watchIntro" :class="{ ' main': scene === 'mainPage' }">
      <div
        :class="[scene === 'mainPage' ? 'watchIntroWrapper' : '', foldUp === 2 ? 'max-wrap' : '']"
      >
        <!-- 佩戴效果 -->
        <div class="wearResults" v-if="watchSizeData && watchSizeData.length">
          <h3 class="secTitle">佩戴效果</h3>
          <div class="wearContent">
            <img :src="$setPicSize(selctedData.wearingImg, 638)" class="pic" />
            <p class="picDesc" v-if="selctedData.wearText">{{ selctedData.wearText }}</p>
            <p class="picDesc" v-else>
              * 佩戴效果非本商品，示例图表壳直径<span class="picDesc-span">{{
                selctedData.showText || ''
              }}</span
              >。
            </p>
            <p class="wristSizeDesc">手腕尺寸（cm）</p>
            <div class="wristSizeWrapper">
              <div
                v-for="(_item, _idx) in watchSizeData"
                :key="_idx"
                @click.stop="onTabClk(_idx)"
                class="sizetab"
                :class="{ ' selected': selectedIndex === _idx }"
              >
                {{ _item.title }}
              </div>
            </div>
            <!-- <img
              :src="
                $setPicSize(
                  'https://pic6.zhuanstatic.com/zhuanzh/344fa41e-b7a8-4634-96d0-79892f2b2d59.png'
                )
              "
              class="arrow"
            /> -->
          </div>
        </div>
        <div class="img-wrapper">
          <img
            v-for="(item, index) in bottomImgList"
            :key="index"
            :src="$setPicSize(item, 638)"
            class="firstPic"
          />
        </div>
      </div>
    </div>

    <SeeMore
      :onClkSeeMore="onClkSeeMore"
      v-if="scene === 'mainPage' && bottomImgList && bottomImgList.length"
      :goodsInfo="goodsInfo"
    ></SeeMore>
  </div>
</template>
<script lang="ts">
import { defineComponent, onMounted, ref, Ref, computed } from '@vue/composition-api'

import SeeMore from '../SeeMore.vue'

export default defineComponent({
  components: {
    SeeMore
  },
  props: {
    goodsInfo: {
      type: Object as any,
      default: () => {}
    },
    eventBus: {
      type: Object
    },
    scene: {
      type: String,
      default: ''
    }
  },
  setup(props) {
    // const { proxy } = getCurrentInstance() as ComponentInternalInstance
    const foldUp = ref(1) // TODO: 二奢融合 增加查看全部
    const selectedIndex: Ref<number> = ref(0)

    /**
     * $ 佩戴效果数据
     */
    // TODO: 二奢融合
    const wearingPopUp = computed(() => {
      return props?.goodsInfo?.wearingInfo?.wearingPopUp
    })
    /**
     * $ 当前tab下的数据
     */
    const selctedData = computed(() => {
      return watchSizeData.value[selectedIndex.value] || {}
    })

    /**
     * $ 腕表尺寸
     */
    const watchSizeData = computed(() => {
      return wearingPopUp?.value.sizeInfos
    })

    /**
     * $ 腕表参数
     */
    // TODO: 二奢融合
    const bottomImgList = computed(() => {
      return wearingPopUp.value?.bottomImgList || []
    })

    const sexSizeConfig = computed(() => {
      if (+props.goodsInfo?.pgCate?.childCateId === 1100001005) {
        // 男腕表
        return {
          pic: 'https://pic2.zhuanstatic.com/zhuanzh/64641c3e-1605-4990-8638-5d420564e777.png',
          desc: '男士腕周及表盘参数',
          diameter: '40mm'
        }
      } else if (+props.goodsInfo?.pgCate?.childCateId === 1100001007) {
        // 女腕表
        return {
          pic: 'https://pic4.zhuanstatic.com/zhuanzh/2b628377-399a-480c-9e4f-bcae0353d53a.png',
          desc: '女士腕周及表盘参数',
          diameter: '28mm'
        }
      }

      return {
        //
      }
    })

    function onTabClk(index) {
      selectedIndex.value = index
    }

    function onClkSeeMore(data) {
      foldUp.value = data
    }

    onMounted(async () => {})

    return {
      watchSizeData,
      selectedIndex,
      selctedData,
      // measureRef,
      sexSizeConfig,
      onTabClk,
      onClkSeeMore,
      foldUp,
      wearingPopUp,
      bottomImgList
    }
  }
})
</script>
<style lang="scss" scoped>
/deep/ .z-popup--bottom {
  min-height: 812px;
}
.picArea {
  display: flex;
  align-items: center;
  width: 686px;
  height: 380px;
  margin: 0 auto;
  background: #f8f8f8;
  border-radius: 16px;
  img {
    width: 686px;
    height: 380px;
    object-fit: cover;
  }
}
.measureDesc {
  margin: 24px 0 64px;
  margin-bottom: 128px;
  color: #666;
  font-weight: 300;
  font-size: 24px;
  font-family: PingFangSC-Light, PingFang SC;
  line-height: 36px;
  text-align: center;
}
.watchIntro {
  box-sizing: border-box;
  width: 686px;
  margin: 0 auto;
  padding: 50px 0 32px;
  background: #f8f8f8;
  border-radius: 16px;
  // &.main {
  //   padding: 40px 0 0 24px;
  // }
  .watchIntroWrapper {
    // max-height: 1000px;
    max-height: 1711px;
    overflow-y: hidden;
  }
  .max-wrap {
    max-height: 6000px;
    overflow: hidden;
  }
  .secTitle {
    color: #111111;
    font-weight: 300;
    font-size: 28px;
    font-family: PingFangSC-Light, PingFang SC;
    line-height: 1;
  }
  .wearResults {
    margin: 0 24px;
    color: #111111;
    font-weight: 300;
    font-size: 28px;
    font-family: PingFangSC-Light, PingFang SC;
    line-height: 1;
    .wearContent {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      box-sizing: border-box;
      width: 638px;
      margin: 24px 0 0;
      // padding: 0 24px;
      background: #ffffff;
      border-radius: 16px 16px 0 0;
      .pic {
        width: 638px;
        height: 288px;
        object-fit: cover;
      }
      .picDesc {
        margin: 16px auto 0;
        color: #999999;
        font-weight: 300;
        font-size: 20px;
        font-family: PingFangSC-Light, PingFang SC;
        line-height: 30px;
        .priDesc-span {
          font-weight: 600;
        }
      }
      .wristSizeDesc {
        align-self: flex-start;
        margin: 48px 0 0 32px;
        color: #111111;
        font-weight: 300;
        font-size: 24px;
        font-family: PingFangSC-Light, PingFang SC;
        line-height: 1;
      }
      .wristSizeWrapper {
        display: flex;
        align-self: flex-start;
        width: 574px;
        height: 48px;
        margin: 26px 0 0 32px;
        background: #bbbbbb;
        background: rgba(187, 187, 187, 0.15);
        border-radius: 4px;
        .sizetab {
          display: flex;
          flex: 1;
          align-items: center;
          justify-content: center;
          box-sizing: border-box;
          height: 48px;
          color: #666666;
          font-weight: 300;
          font-size: 24px;
          font-family: PingFangSC-Light, PingFang SC;

          &.selected {
            box-sizing: border-box;
            height: 44px;
            margin: auto 2px;
            color: #111111;
            font-weight: 500;
            font-size: 24px;
            font-family: PingFang-SC-Medium, PingFang-SC;
            background: #ffffff;
            border-radius: 2px;
          }
        }
      }
      .arrow {
        position: relative;
        width: 100%;
        height: 228px;
        margin-top: 20px;
        object-fit: cover;
      }
    }
  }

  .img-wrapper {
    img {
      width: 100%;
    }
  }

  .sizeMeasure {
    margin-bottom: 40px;
    .firstPic {
      width: 638px;
      height: 410px;
      margin: 24px 0 0;
      background: #ffffff;
      border-radius: 16px;
    }
    .secPic {
      width: 638px;
      height: 522px;
      margin: 16px 0 0;
      background: #ffffff;
      border-radius: 16px;
    }
    .sizeMeasureDesc {
      margin: 24px 0 0;
      color: #999999;
      font-weight: 300;
      font-size: 20px;
      font-family: PingFangSC-Light, PingFang SC;
      line-height: 30px;
    }
  }
  .upkeep {
    &-content {
      box-sizing: border-box;
      width: 638px;
      margin: 24px 0 40px;
      padding: 40px 32px;
      background: #ffffff;
      border-radius: 16px;
      &-firSec {
        &-secTitle {
          color: #111111;
          font-weight: 500;
          font-size: 24px;
          font-family: PingFang-SC-Medium, PingFang-SC;
          line-height: 1;
        }
        &-mainContent {
          display: flex;
          justify-content: space-between;
          box-sizing: border-box;
          width: 574px;
          margin: 32px 0 0;
          .leftPic {
            width: 225px;
            height: 248px;
            object-fit: cover;
          }
          .rightContent {
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            height: 228px;
            margin: 10px 0;
            color: #666666;
            font-weight: 300;
            font-size: 24px;
            font-family: PingFangSC-Light, PingFang SC;
            line-height: 36px;
          }
        }
      }
      &-secSec {
        margin: 64px 0 0;
      }
    }
  }
  .sizePic {
    img {
      width: 638px;
      height: 366px;
      margin: 24px 0 0;
      object-fit: cover;
    }
  }
}
</style>
